import React,{useReducer, createContext} from "react";
import reducer, { initialize } from "../Reducer/reducer";

//prepare to data layer

export const StateContext=createContext();

export const StateProvider =(props)=>{
 
const [state, dispatch]=useReducer(reducer,initialize)
    const info={state, dispatch};

         
    return <StateContext.Provider value={info}>
    
    {props.children}
    
    </StateContext.Provider>


}

export const useStateValue = () => React.useContext(StateContext);
 



